import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Rating from '@mui/material/Rating'; // Import Rating component
import Typography from '@mui/material/Typography';
import { storyblokEditable } from '@storyblok/react';
import { memo } from 'react';

import useStoryblokImage from '../../../util/hooks/useStoryblokImage';
import ProgressiveImage from '../../Image/ProgressiveImage';
import { withBaseComponent } from '../hoc/withBaseComponent';

/**
 * @param {object} props
 * @param {object} props.blok
 */
const StoryblokTestimonialCardComponent = ({ blok }) => {
  const { general } = blok;
  const { content, name, subTitle, image, rating } = general;
  const { src, blurSrc, sources, blurSources } = useStoryblokImage(image.filename, {
    size: 320,
    blurSize: 160,
  });

  return (
    <Paper
      elevation={4}
      {...storyblokEditable(blok)}
      sx={{
        padding: 4,
      }}
    >
      <Grid container>
        <Grid container size={12}>
          <Grid
            size={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 100,
                height: 100,
                borderRadius: '50%',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <ProgressiveImage
                alt={image.alt}
                blurSources={blurSources}
                blurSrc={blurSrc}
                height="100%"
                imageStyle={{
                  objectFit: 'contain',
                }}
                sources={sources}
                src={src}
                title={image.title}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography component="div" marginBottom={0} variant="h4">
                {name}
              </Typography>
              <Typography component="div" marginTop={0} variant="subtitle1">
                {subTitle}
              </Typography>
              {/* Add the Rating component below the subTitle */}
              <Rating readOnly value={parseFloat(rating)} />
            </Box>
          </Grid>
        </Grid>
        <Grid size={12}>
          <Typography component="div" variant="body1">
            {content}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

StoryblokTestimonialCardComponent.displayName = 'StoryblokTestimonialCard';
const StoryblokTestimonialCard = withBaseComponent(StoryblokTestimonialCardComponent);

export default memo(StoryblokTestimonialCard);
